<template>
  <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Eventos:"
    id="selectEvento"
    placeholder="Selecione o(s) evento(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import EventRepository from '@/shared/http/repositories/configurations/event.js'

export default {
  name: 'NxSelectEvento',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadEventos()
  },
  methods: {
    onLoadEventos () {
      EventRepository.GetAll()
        .then((response) => {
          console.log(response)
          let result = response.data.content
            .map((x) => ({'value': x.id, 'text': x.nome}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Eventos', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectEvento.vue